import {Loc} from 'landing.loc';

export const HsIcons = {
	id: 'hs_icons',
	name: 'HS Icons',
	active: true,
	categories: [
		{
			id: 'hs_icons_all',
			name: Loc.getMessage('LANDING_ICONS_SIMPLE_LINE_ICONS_ALL'),
			items: [
				'hs-icon hs-icon-arrow-bottom',
				'hs-icon hs-icon-arrow-left',
				'hs-icon hs-icon-arrow-right',
				'hs-icon hs-icon-arrow-top',
				'hs-icon hs-icon-close',
				'hs-icon hs-icon-hamburger-2',
				'hs-icon hs-icon-hamburger',
				'hs-icon hs-icon-lula-kebab-h',
				'hs-icon hs-icon-lula-kebab-v',
				'hs-icon hs-icon-magnifier',
				'hs-icon hs-icon-music',
				'hs-icon hs-icon-photo',
				'hs-icon hs-icon-play',
				'hs-icon hs-icon-plus',
				'hs-icon hs-icon-unzoom',
				'hs-icon hs-icon-video',
				'hs-icon hs-icon-zoom',
			],
		},
	],
};